(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  function formatMoney(cents, format) {
    const brace = String.fromCharCode(123);
    const closeBrace = String.fromCharCode(125);
    const placeholderRegex = new RegExp(brace + brace + '\\s*(\\w+)\\s*' + closeBrace + closeBrace);
    const formatString = format || '$' + brace + brace + 'amount' + closeBrace + closeBrace;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;

      const parts = (number / 100).toFixed(precision).split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
      const remainder = parts[1] ? decimal + parts[1] : '';

      return dollars + remainder;
    }

    let value;
    switch ((formatString.match(placeholderRegex) || [])[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(cents, 0, ' ');
        break;
      default:
        value = withDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  function initCartQuantitySteppers(root) {
    root.querySelectorAll('.quantity-stepper').forEach((stepper) => {
      const input = stepper.querySelector('[data-quantity-input]');
      const increaseButton = stepper.querySelector('[data-quantity-increase]');
      const decreaseButton = stepper.querySelector('[data-quantity-decrease]');

      increaseButton.addEventListener('click', () => {
        input.value = Number(input.value || 0) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      decreaseButton.addEventListener('click', () => {
        const min = Number(input.min) || 0;
        input.value = Math.max(min, Number(input.value || 0) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      input.addEventListener('change', () => {
        updateCartItemQuantity(input.dataset.cartItemKey, Number(input.value));
      });
    });
  }

  function updateCartItemQuantity(key, quantity) {
    const cartSection = document.querySelector('[data-cart-section]');
    if (!cartSection) return;

    const changeUrl = cartSection.dataset.cartChangeUrl;
    const moneyFormat = cartSection.dataset.moneyFormat;

    fetch(`${changeUrl}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then((response) => response.json())
      .then((cart) => {
        if (cart.item_count === 0) {
          window.location.reload();
          return;
        }

        const row = cartSection.querySelector(`[data-cart-row="${key}"]`);
        const updatedItem = cart.items.find((item) => item.key === key);

        if (!updatedItem) {
          row?.remove();
        } else {
          const priceEl = row?.querySelector('[data-line-price]');
          if (priceEl) priceEl.textContent = formatMoney(updatedItem.final_line_price, moneyFormat);
        }

        const subtotalEl = cartSection.querySelector('[data-cart-subtotal]');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price, moneyFormat);
      })
      .catch((error) => {
        console.error('Failed to update cart', error);
        window.location.reload();
      });
  }

  initCartQuantitySteppers(document);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('.collection-sort__select').forEach((select) => {
    select.addEventListener('change', () => select.form.submit());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comic-reader"]) return;
  try {
    
  document.querySelectorAll('[data-comic-reader]').forEach(function (reader) {
    var pages = Array.prototype.slice.call(reader.querySelectorAll('[data-comic-page]'));
    var total = pages.length;
    var prevButton = reader.querySelector('[data-comic-prev]');
    var nextButton = reader.querySelector('[data-comic-next]');
    var currentLabel = reader.querySelector('[data-comic-current]');
    var modeButtons = Array.prototype.slice.call(reader.querySelectorAll('[data-comic-mode]'));
    var modesEl = reader.querySelector('[data-comic-modes]');
    var scrollContainer = reader.querySelector('.comic-reader__main');
    var current = 0;
    var lastScrollTop = 0;

    if (total === 0) return;

    function render() {
      pages.forEach(function (page, index) {
        page.classList.toggle('is-current', index === current);
      });

      if (currentLabel) currentLabel.textContent = String(current + 1);
      if (prevButton) prevButton.disabled = current === 0;
      if (nextButton) nextButton.disabled = current === total - 1;
    }

    function goTo(index) {
      current = Math.max(0, Math.min(total - 1, index));
      render();
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        goTo(current - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        goTo(current + 1);
      });
    }

    modeButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        reader.setAttribute('data-mode', button.getAttribute('data-comic-mode'));
        modeButtons.forEach(function (otherButton) {
          otherButton.setAttribute('aria-pressed', String(otherButton === button));
        });

        if (modesEl) modesEl.classList.remove('is-hidden');
        if (scrollContainer) lastScrollTop = scrollContainer.scrollTop;
      });
    });

    document.addEventListener('keydown', function (event) {
      if (reader.getAttribute('data-mode') !== 'traditional') return;
      if (event.key === 'ArrowLeft') goTo(current - 1);
      if (event.key === 'ArrowRight') goTo(current + 1);
    });

    if (scrollContainer && modesEl) {
      scrollContainer.addEventListener(
        'scroll',
        function () {
          var scrollTop = scrollContainer.scrollTop;
          var delta = scrollTop - lastScrollTop;

          if (Math.abs(delta) < 8) return;

          if (delta > 0 && scrollTop > 40) {
            modesEl.classList.add('is-hidden');
          } else {
            modesEl.classList.remove('is-hidden');
          }

          lastScrollTop = scrollTop;
        },
        { passive: true }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-work"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.featured-work__carousel').forEach((carousel) => {
    const track = carousel.querySelector('.featured-work__track');
    const prevButton = carousel.querySelector('.featured-work__nav--prev');
    const nextButton = carousel.querySelector('.featured-work__nav--next');

    if (!track || (!prevButton && !nextButton)) return;

    const originalItems = Array.from(track.children);
    if (originalItems.length < 2) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const measureUnit = () => {
      const last = originalItems[originalItems.length - 1];
      return last.offsetLeft + last.offsetWidth - originalItems[0].offsetLeft;
    };

    // Each side needs enough cloned copies of the full item set to cover at
    // least two viewports of scrolling before a loop correction is needed —
    // otherwise, on wide viewports showing more items than fit in one set,
    // the browser's native scroll limit is reached before the loop point.
    let unit = measureUnit();
    const repeats = Math.max(2, Math.ceil((track.clientWidth * 2) / unit));

    const cloneSet = () => {
      const nodes = [];
      for (let i = 0; i < repeats; i++) {
        originalItems.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('img').forEach((img) => img.removeAttribute('loading'));
          clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
          nodes.push(clone);
        });
      }
      return nodes;
    };

    track.prepend(...cloneSet());
    track.append(...cloneSet());

    let anchor = repeats * unit;
    track.scrollLeft = anchor;

    const scrollByDirection = (direction) => {
      const item = track.querySelector('.featured-work__item');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const amount = item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;

      track.scrollBy({
        left: amount * direction,
        behavior: reducedMotion ? 'auto' : 'smooth',
      });
    };

    const loopIfNeeded = () => {
      const delta = track.scrollLeft - anchor;

      if (delta >= unit) {
        track.scrollLeft -= unit;
      } else if (delta <= -unit) {
        track.scrollLeft += unit;
      }
    };

    let settleTimer;
    track.addEventListener(
      'scroll',
      () => {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(loopIfNeeded, 80);
      },
      { passive: true },
    );
    track.addEventListener('scrollend', loopIfNeeded);

    prevButton?.addEventListener('click', () => scrollByDirection(-1));
    nextButton?.addEventListener('click', () => scrollByDirection(1));
    window.addEventListener('resize', () => {
      unit = measureUnit();
      anchor = repeats * unit;
      track.scrollLeft = anchor;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const HEADER_MENU_SELECTOR = 'details.header__menu';
  const DESKTOP_QUERY = window.matchMedia('(width >= 1100px)');

  function closeHeaderMenus() {
    document.querySelectorAll(`${HEADER_MENU_SELECTOR}[open]`).forEach((menu) => {
      menu.open = false;
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const openMenu = document.querySelector(`${HEADER_MENU_SELECTOR}[open]`);
    if (!openMenu) return;

    openMenu.open = false;
    openMenu.querySelector('summary')?.focus();
  });

  DESKTOP_QUERY.addEventListener('change', (event) => {
    if (event.matches) closeHeaderMenus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('.product-gallery').forEach((gallery) => {
    const mainImage = gallery.querySelector('[data-product-gallery-image]');
    const thumbnails = gallery.querySelectorAll('[data-product-gallery-thumbnail]');

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        if (!mainImage) return;

        mainImage.src = thumbnail.dataset.fullSrc;
        mainImage.srcset = thumbnail.dataset.fullSrcset;
        mainImage.alt = thumbnail.dataset.fullAlt;

        thumbnails.forEach((item) => item.classList.remove('is-active'));
        thumbnail.classList.add('is-active');
      });
    });
  });

  document.querySelectorAll('.quantity-stepper').forEach((stepper) => {
    const input = stepper.querySelector('[data-quantity-input]');
    const increaseButton = stepper.querySelector('[data-quantity-increase]');
    const decreaseButton = stepper.querySelector('[data-quantity-decrease]');

    increaseButton.addEventListener('click', () => {
      input.value = Number(input.value || 1) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    decreaseButton.addEventListener('click', () => {
      const min = Number(input.min) || 1;
      input.value = Math.max(min, Number(input.value || 1) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["release-spotlight"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pad = (n) => String(n).padStart(2, '0');

    function tick(el) {
      const start = Date.parse(el.dataset.start || '');
      const end = Date.parse(el.dataset.end || '');
      if (Number.isNaN(end)) return false;

      const now = Date.now();
      let target;
      let label;

      if (!Number.isNaN(start) && now < start) {
        target = start;
        label = el.dataset.labelBefore || 'Starts in';
      } else if (now < end) {
        target = end;
        label = el.dataset.labelDuring || 'Ends in';
      } else {
        el.hidden = true;
        const done = el.parentNode.querySelector('[data-spot-fallback]');
        if (done) done.hidden = false;
        return false;
      }

      let diff = Math.max(0, Math.floor((target - now) / 1000));
      const d = Math.floor(diff / 86400);
      diff -= d * 86400;
      const h = Math.floor(diff / 3600);
      diff -= h * 3600;
      const m = Math.floor(diff / 60);
      const s = diff - m * 60;

      el.querySelector('[data-spot-label]').textContent = label;
      el.querySelector('[data-unit="d"]').textContent = d;
      el.querySelector('[data-unit="h"]').textContent = pad(h);
      el.querySelector('[data-unit="m"]').textContent = pad(m);
      el.querySelector('[data-unit="s"]').textContent = pad(s);
      el.hidden = false;
      const fallback = el.parentNode.querySelector('[data-spot-fallback]');
      if (fallback) fallback.hidden = true;
      return true;
    }

    let timerInterval;

    function init() {
      clearInterval(timerInterval);
      const timers = [...document.querySelectorAll('[data-spot-countdown]')];
      if (!timers.length) return;
      const run = () => timers.forEach(tick);
      run();
      timerInterval = setInterval(run, 1000);
    }

    function initCarousel(root) {
      if (root.dataset.spotReady) return;
      root.dataset.spotReady = 'true';

      const grid = root.querySelector('.spot__grid');
      const cards = [...grid.children];
      const dots = [...root.querySelectorAll('[data-spot-dot]')];
      const prev = root.querySelector('[data-spot-prev]');
      const next = root.querySelector('[data-spot-next]');
      if (!grid || cards.length < 2) return;

      const offsetOf = (card) => card.offsetLeft - cards[0].offsetLeft;

      const current = () => {
        let best = 0;
        let bestDist = Infinity;
        cards.forEach((card, i) => {
          const dist = Math.abs(offsetOf(card) - grid.scrollLeft);
          if (dist < bestDist) {
            bestDist = dist;
            best = i;
          }
        });
        // At the far end of the row, the last card counts as current.
        if (grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 4) best = cards.length - 1;
        return best;
      };

      const update = () => {
        const i = current();
        dots.forEach((dot, d) => dot.setAttribute('aria-current', d === i ? 'true' : 'false'));
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === cards.length - 1;
      };

      const go = (i) => {
        const target = cards[Math.max(0, Math.min(cards.length - 1, i))];
        grid.scrollTo({ left: offsetOf(target), behavior: 'smooth' });
      };

      prev?.addEventListener('click', () => go(current() - 1));
      next?.addEventListener('click', () => go(current() + 1));
      dots.forEach((dot, d) => dot.addEventListener('click', () => go(d)));

      let raf;
      grid.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(update);
      }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    function initAll() {
      init();
      document.querySelectorAll('[data-spot]').forEach(initCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
